import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=377c0a3c&scoped=true"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=377c0a3c&prod&lang=scss&scoped=true"
import style1 from "./RegisterUser.vue?vue&type=style&index=1&id=377c0a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c0a3c",
  null
  
)

export default component.exports